import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Loader2 } from '@/components/ui/icons';

import { Sidebar } from './Sidebar';
import { HomepageProvider } from '@/contexts/HomepageContext';
import { ManualCadProvider } from '@/contexts/ManualCadContext';
import { useAuth } from '@/contexts/AuthContext';

import { LayoutContent } from './layout/LayoutContent';

export function Layout() {
  // Gate the shell on auth-only loading so the viewer + data queries render as
  // soon as the session resolves, instead of blocking ~1s+ on billing-status.
  // Token/limit UI inside still reads the billing-aware isLoading. (issue #58)
  const { user, isAuthLoading } = useAuth();

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem('sidebarOpen') !== 'false',
  );

  useEffect(() => {
    localStorage.setItem('sidebarOpen', isSidebarOpen.toString());
  }, [isSidebarOpen]);

  if (isAuthLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-telekinesis-bg-secondary-dark">
        <Loader2 className="h-8 w-8 animate-spin text-[#107d40]" />
      </div>
    );
  }

  if (!user) {
    return (
      <HomepageProvider>
        <div className="flex h-dvh overflow-hidden">
          <Outlet context={{ isSidebarOpen }} />
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </div>
      </HomepageProvider>
    );
  }

  return (
    <HomepageProvider>
      {/* ManualCadProvider holds the live Manual-CAD session (feature list + Tip
          mesh) shared by the toolbar feature bar, the sidebar tree, and the
          manual viewport. Only the authed shell — Manual CAD needs a JWT. */}
      <ManualCadProvider>
        <LayoutContent
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          onToggleRightSidebar={() => setIsSidebarOpen((v) => !v)}
        />
      </ManualCadProvider>
    </HomepageProvider>
  );
}
